window.$ = window.jQuery = require('jquery');
require('magnific-popup');
require('popper.js');
require('bootstrap');

$(() => {
    "use strict";
    require('../../partials/block/feedback-form/feedback-form')
    require('../../partials/header/header');

    $('.popup-gallery').find('img').each(function () {
        let src = $(this).attr('src');
        $(this).parent().wrapInner("<a href='"+src+"'></a>");
    });

    $('.popup-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        image: {
            tError: '<a href="%url%">Изображение #%curr%</a> не может быть загружено.',
            titleSrc: function(item) {
                return item.el.attr('title');
            }
        }
    });
});
